module.exports = __webpack_public_path__ + "static/post-office-3318f2944dc6b63a9923ef465bad5045.mp4";